import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, PhoneIcon } from 'lucide-react';
import { EmblemDivider } from './Emblem';
export function Founder() {
  return <section id="founder" className="paper-texture border-y border-gold/15 overflow-hidden" data-id="element-296">
      <div className="container-custom py-16 md:py-24" data-id="element-297">
        <EmblemDivider className="mb-14 md:mb-16" data-id="element-298" />

        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center" data-id="element-299">
          {/* Portrait */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.9
        }} className="lg:col-span-5" data-id="element-300">
            <div className="relative max-w-md mx-auto" data-id="element-301">
              {/* Main circular portrait */}
              <div className="relative aspect-square w-full rounded-full overflow-hidden border-[6px] border-background shadow-[0_30px_60px_-15px_rgba(31,27,23,0.25)]" data-id="element-302">
                {/* [VERIFY] — replace with real photograph of James Sinclair */}
                <img src="https://cdn.magicpatterns.com/uploads/5vgMgR3JMFMrdtmBeJtrqm/sn4.webp" alt="James Sinclair designing a custom engagement ring in CAD at the Sinclair's Ardross workshop" className="absolute inset-0 w-full h-full object-cover" data-id="element-303" />
              </div>

              {/* Caption beneath */}
              <div className="text-center mt-7" data-id="element-304">
                <p className="signature text-5xl md:text-6xl text-gold-dark leading-none mb-3" data-id="element-305">
                  James Sinclair
                </p>
                <p className="brand-mark text-[0.7rem] uppercase text-muted" data-id="element-306">
                  Principal Jeweller
                </p>
                <p className="text-xs text-secondary italic mt-2" data-id="element-307">
                  The Sinclair family · Jewellers in Ardross since 1947
                </p>
              </div>
            </div>
          </motion.div>

          {/* Letter */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.9,
          delay: 0.1
        }} className="lg:col-span-7" data-id="element-308">
            <span className="eyebrow" data-id="element-309">A note from the principal</span>
            <h2 className="font-serif text-3xl md:text-4xl lg:text-[2.75rem] font-medium leading-[1.1] mb-8 text-balance" data-id="element-310">
              "If you're a little nervous about{' '}
              <span className="italic text-gold-dark" data-id="element-311">your jewellery</span>,
              that's exactly why we exist."
            </h2>

            <div className="space-y-5 text-secondary text-[1.05rem] leading-relaxed text-pretty mb-8 max-w-2xl" data-id="element-312">
              <p data-id="element-313">
                Most people who walk into our shop are holding something that
                matters. An idea for a proposal. A ring inherited from a mother.
                A stone they haven't quite trusted to anyone yet.
              </p>
              <p data-id="element-314">
                My father started Sinclair's in 1947 on the simple promise that
                meaningful jewellery deserves to be made — and looked after — by
                someone you actually know. Generations later, that hasn't
                changed.
              </p>
              <p data-id="element-315">
                When you come to us, you'll meet a professional jewellery
                consultant, trained by Sinclair's. You'll see where your piece
                of jewellery is designed, crafted and finished. You'll never be
                rushed, never upsold, and under the care of Sinclair's from
                start to finish.
              </p>
              <p className="text-primary font-medium" data-id="element-316">
                If you're thinking about a ring, a repair, or a remodel — let's
                have a quiet conversation first. The kettle's always on.
              </p>
            </div>

            {/* Signature block */}
            <div className="mb-10 pl-1" data-id="element-317">
              <p className="signature text-5xl md:text-6xl text-primary leading-none" data-id="element-318">
                James
              </p>
              <p className="text-xs text-muted mt-2 brand-mark uppercase" data-id="element-319">
                James Sinclair · Principal Jeweller · Sinclair's of Ardross
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-3" data-id="element-320">
              <a href="#consultation" className="btn-primary group" data-id="element-321">
                Speak with James directly
                <ArrowRightIcon className="w-4 h-4 ml-2 transition-transform group-hover:translate-x-1" data-id="element-322" />
              </a>
              <a href="tel:0893162321" className="btn-secondary" data-id="element-323">
                <PhoneIcon className="w-4 h-4 mr-2 text-gold" data-id="element-324" />
                Or call the workshop
              </a>
            </div>
          </motion.div>
        </div>

        <EmblemDivider className="mt-16" data-id="element-325" />
      </div>
    </section>;
}